module.exports = __webpack_public_path__ + "media/application/images/2018/facebook-red@2x-5c9995d527e65a1414ffe89c8ee96db2.png";